// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__w_ucr","label":"styles_label__1n9ms","content":"styles_content__2Ozp-","done":"styles_done__1PvzU"};